<div class="video">
  <div class="video-placeholder" [id]="elementId"></div>
</div>
